import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicyFR() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Retour à l'application
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Responsable du Traitement des Données</h2>
              <div className="space-y-3 bg-gray-50 p-4 rounded-lg">
                <p className="leading-relaxed">
                  <strong>Le responsable du traitement est :</strong>
                </p>
                <div className="ml-4 space-y-1">
                  <p><strong>Nom :</strong> Puretech s.r.o.</p>
                  <p><strong>Numéro d'enregistrement :</strong> 05503795</p>
                  <p><strong>Emplacement :</strong> République tchèque</p>
                  <p><strong>Contact :</strong> support@simplestickers.app</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Informations que Nous Collectons</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Informations de compte :</strong> Lorsque vous créez un compte, nous collectons votre adresse e-mail et toute information de profil que vous choisissez de fournir.
                </p>
                <p className="leading-relaxed">
                  <strong>Données d'utilisation :</strong> Nous collectons des informations sur la façon dont vous utilisez notre service, y compris les tâches créées, les projets gérés et les modèles d'utilisation des fonctionnalités.
                </p>
                <p className="leading-relaxed">
                  <strong>Informations de paiement :</strong> Le traitement des paiements est géré par Polar. Nous ne stockons pas les détails de votre carte de paiement sur nos serveurs.
                </p>
                <p className="leading-relaxed">
                  <strong>Données techniques :</strong> Nous collectons automatiquement certaines informations techniques, notamment l'adresse IP, le type de navigateur, le système d'exploitation et les informations sur l'appareil.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Comment Nous Utilisons Vos Informations</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Nous utilisons les informations que nous collectons pour :</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Fournir, maintenir et améliorer nos services</li>
                  <li>Traiter les transactions et gérer les abonnements</li>
                  <li>Vous envoyer des notifications techniques et des messages d'assistance</li>
                  <li>Répondre à vos commentaires et questions</li>
                  <li>Analyser les modèles d'utilisation pour améliorer l'expérience utilisateur</li>
                  <li>Faire respecter nos conditions générales</li>
                  <li>Se conformer aux obligations légales</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Partage d'Informations</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nous ne vendons pas, n'échangeons pas et ne transférons pas vos informations personnelles à des tiers, sauf dans les cas décrits dans cette politique :
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Fournisseurs de services :</strong> Nous pouvons partager des informations avec des tiers de confiance qui nous aident à exploiter notre service (par exemple, Polar pour le traitement des paiements, Supabase pour les services de base de données)</li>
                  <li><strong>Exigences légales :</strong> Nous pouvons divulguer des informations lorsque la loi l'exige ou pour protéger nos droits</li>
                  <li><strong>Transferts commerciaux :</strong> En cas de fusion, d'acquisition ou de vente d'actifs, les informations des utilisateurs peuvent être transférées</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Sécurité des Données</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos informations personnelles contre l'accès non autorisé, la modification, la divulgation ou la destruction. Cependant, aucune méthode de transmission sur Internet n'est sûre à 100 %.
                </p>
                <p className="leading-relaxed">
                  <strong>Réponse aux violations de sécurité :</strong> En cas de violation de données personnelles, nous respecterons le RGPD :
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Signaler l'incident à l'autorité de contrôle dans les 72 heures suivant la découverte</li>
                  <li>Notifier les utilisateurs concernés si la violation présente un risque élevé pour leurs droits et libertés</li>
                  <li>Prendre des mesures pour minimiser l'impact et prévenir les incidents futurs</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Conservation des Données</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nous conservons vos informations personnelles aussi longtemps que nécessaire pour fournir nos services. Les périodes de conservation spécifiques sont :
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Données de compte :</strong> Durée du service + 30 jours après la suppression du compte</li>
                  <li><strong>Contenu des tâches (notes autocollantes) :</strong> Jusqu'à ce que vous les supprimiez ou que vous annuliez votre compte</li>
                  <li><strong>Enregistrements de paiement :</strong> 7 ans (exigence de la loi comptable tchèque)</li>
                  <li><strong>Données analytiques :</strong> Jusqu'à 26 mois</li>
                  <li><strong>Données de sauvegarde :</strong> Peuvent persister jusqu'à 90 jours après la suppression principale</li>
                  <li><strong>Données anonymisées :</strong> Conservées indéfiniment à des fins statistiques</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Vos Droits en Vertu du RGPD</h2>
              <div className="space-y-2">
                <p className="leading-relaxed">Vous avez le droit de :</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Accéder aux informations personnelles que nous détenons à votre sujet</li>
                  <li>Corriger toute information personnelle inexacte</li>
                  <li>Demander la suppression de vos informations personnelles</li>
                  <li>Vous opposer ou limiter le traitement de vos informations</li>
                  <li>Portabilité des données (recevoir une copie de vos données dans un format structuré)</li>
                  <li>Retirer votre consentement à tout moment</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Cookies et Suivi</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nous utilisons des cookies et des technologies de suivi similaires pour améliorer votre expérience. Types de cookies que nous utilisons :
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du service (authentification, connexion)</li>
                  <li><strong>Cookies analytiques :</strong> Nous aident à comprendre comment vous utilisez notre service (vous pouvez refuser)</li>
                  <li><strong>Cookies tiers :</strong> Google OAuth, Polar pour les paiements</li>
                </ul>
                <p className="leading-relaxed">
                  Vous pouvez contrôler les paramètres des cookies via les préférences de votre navigateur ou notre bannière de cookies lors de la première visite.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Services Tiers</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">Notre service s'intègre avec des services tiers :</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li><strong>Google OAuth :</strong> Pour l'authentification (soumis à la politique de confidentialité de Google)</li>
                  <li><strong>Polar :</strong> Pour le traitement des paiements (soumis à la politique de confidentialité de Polar)</li>
                  <li><strong>Supabase :</strong> Pour les services de base de données et d'authentification</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Confidentialité des Enfants</h2>
              <p className="leading-relaxed">
                Notre service n'est pas destiné aux enfants de moins de 16 ans. Nous ne collectons pas sciemment d'informations personnelles auprès d'enfants de moins de 16 ans. Si vous êtes un parent ou un tuteur et pensez que votre enfant nous a fourni des informations personnelles, veuillez nous contacter à support@simplestickers.app.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Transferts Internationaux de Données</h2>
              <p className="leading-relaxed">
                Vos informations peuvent être transférées et traitées dans des pays autres que votre pays de résidence. Nous veillons à ce que des garanties appropriées soient en place pour protéger vos informations personnelles conformément aux lois applicables en matière de protection des données.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Modifications de Cette Politique</h2>
              <p className="leading-relaxed">
                Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Nous vous informerons de tout changement important en publiant la nouvelle politique sur cette page et en mettant à jour la date de "Dernière mise à jour".
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Prise de Décision Automatisée</h2>
              <p className="leading-relaxed">
                Notre service utilise des algorithmes d'IA pour générer des suggestions de tâches. Cette fonctionnalité est purement assistive et ne crée pas de décisions ayant des effets juridiques ou significatifs sur les utilisateurs. Vous pouvez choisir de ne pas utiliser les suggestions à tout moment.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Autorité de Contrôle</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Vous avez le droit de déposer une plainte auprès de l'autorité de contrôle de la protection des données :
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p><strong>Office tchèque de protection des données personnelles (ÚOOÚ)</strong></p>
                  <p className="text-sm mt-2">Pplk. Sochora 27, 170 00 Prague 7</p>
                  <p className="text-sm">Web : <a href="https://www.uoou.cz" className="text-indigo-600 hover:underline">www.uoou.cz</a></p>
                  <p className="text-sm">E-mail : posta@uoou.cz</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Comment Exercer Vos Droits</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Pour exercer vos droits en vertu du RGPD (accès aux données, rectification, suppression, portabilité, opposition, etc.) :
                </p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Envoyez-nous une demande à <strong>support@simplestickers.app</strong></li>
                  <li>Nous répondrons dans un délai de <strong>1 mois</strong> après réception de votre demande</li>
                  <li>Nous pouvons vous demander de vérifier votre identité</li>
                  <li>Le service est <strong>gratuit</strong> (sauf si la demande est manifestement infondée ou excessive)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Nous Contacter</h2>
              <p className="leading-relaxed">
                Si vous avez des questions concernant cette politique de confidentialité ou nos pratiques en matière de données, veuillez nous contacter :
              </p>
              <div className="mt-4 bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>E-mail :</strong> support@simplestickers.app
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  Pour toutes les questions concernant la confidentialité, les demandes de données, l'assistance et autres demandes
                </p>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
